<template>
  <div class="home-content-page-v prediction-source-page">
    <div class="content-1">
      <div class="content-1-table-1 mii-table">
        <content-title :title="'进销存数据 ' + preDay"></content-title>
        <mii-table-oil :datas="showJxcDatas" :columns="jxcThs" :mergeRowKeyList="['加油站名称', '油品名称']" :s_key="['出库升数', '期末库存', '空容']"></mii-table-oil>
      </div>
    </div>
  </div>
</template>

<script>
import ContentTitle from '@/components_bit/ContentTitle'
import MiiTableOil from '@/components_bit/MiiTableOil'

export default {
  name: 'cars',
  components: {
    ContentTitle,
    MiiTableOil
  },
  data () {
    return {
      jxcThs: [{
        label: '加油站',
        key: '加油站名称'
      },
      {
        label: '罐号',
        key: '罐号'
      },
      {
        label: '油品类型',
        key: '油品名称'
      },
      {
        label: '预计空容',
        key: '预计空容'
      },
      {
        label: '入库(L)',
        key: '入库升数'
      },
      {
        label: '出库L',
        key: '出库升数'
      },
      {
        label: '期末L',
        key: '期末库存'
      },
      {
        label: '空容L',
        key: '空容'
      },
      {
        label: '平均销量(L)',
        key: '平均销量'
      },
      {
        label: '在途(L)',
        key: '在途计划升数'
      },
      {
        label: '配送计划(L)',
        key: '配送计划'
      },
      {
        label: '物理容积(L)',
        key: '物理容积'
      },
      {
        label: '停泵库存(L)',
        key: '停泵库存'
      },
      {
        label: '有效容积(L)',
        key: '有效容积'
      }]
    }
  },
  computed: {
    showJxcDatas: {
      get () {
        let datas = this.$store.getters.areaHisJxcDatas
        datas.forEach((item) => {
          item['预计空容'] = (item['空容'] + item['出库升数'] - item['在途计划升数']) || null
        })
        return this.$store.getters.areaHisJxcDatas || []
      }
    },
    preDay: {
      get () {
        return this.$store.getters.todayStr
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.error-rk {
  color: #f7bd34 !important;
}
.edit-td:hover {
  input {
    display: block;
  }
  span {
    display: none;
  }
}
.btm-btn {
  border-radius: 0.25rem;
  background-color: #ffa022;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.7rem;
  letter-spacing: 1px;
  color: #fff;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
}
.edit-td-error {
  color:  #f7bd34 !important;
}
.edit-td-success {
  color: #14cf65 !important;
}
.edit-td {
  width: 7rem;
  text-align: center;
  input {
    width: 6rem;
    margin: 0 auto;
    text-align: center;
    display: none;
  }
  span {
    display: block;
  }
}
.edit-error-num {
  width: 5rem;
}

.gu-duan {
  margin-bottom:0.7em;
  width: 100%;
  .el-select {
    width: 25em;
  }
  display: flex;
  justify-content: space-between;
}
.content-1 {
  border-radius: 0.5em;
  padding: 0.88em 0.7em 2.25em;
  background-color: #e5e5e5;
  display: block;
}
.content-1-tables {
  display: flex;
}
.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table {
  .content-shadow;
  .content-top-radius;
  display: flex;
  flex-direction:column;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  .s-bak-td {
    background-color: #e0e6ea;
    border:0 solid @bak-color-main;
  }
  .jj-bak-td {
    background-color: @bak-color-2;
    color: #00ccff;
  }
  .ps-bak-td {
    background-color: #98aab9;
  }
  table {
    border-spacing: 0px;
    width: 100%;
    th {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      font-weight: 100;
    }
    td {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
    }
  }
}
</style>

<style lang="less">
.prediction-source-page {
  .el-scrollbar__wrap {
    overflow:visible;
  }
  .el-scrollbar {
    overflow:visible;
  }
  .el-select-dropdown {
    overflow: scroll
  }
}
</style>



// WEBPACK FOOTER //
// area_jxc.vue?7ba9a02c